import { Plus, Share } from "lucide-react";

// Looping mock phone: open the browser menu, pick Add to Home Screen / Install, the SnapList icon pops onto the home screen.
export default function PhoneInstallAnimation({ os }) {
  const ios = os === "iphone";
  return (
    <div className="pci-stage relative mx-auto h-64 w-36 overflow-hidden rounded-[1.6rem] border-[5px] border-slate-900 bg-white shadow-xl" data-testid="phone-install-animation" aria-hidden="true">
      <div className="pph-page absolute inset-0 flex flex-col">
        <div className="flex h-6 items-center justify-between bg-slate-100 px-2 text-[7px] text-slate-500">
          <span className="truncate">snaplist.app</span>
          {!ios && <span className="pph-target relative font-bold text-slate-700">⋮</span>}
        </div>
        <div className="flex-1 space-y-1 p-2">
          <div className="h-2 w-1/2 rounded bg-[#0053DA]/80" />
          <div className="h-1.5 w-3/4 rounded bg-slate-200" />
          <div className="grid grid-cols-2 gap-1 pt-1">{[0, 1, 2, 3].map((i) => <div key={i} className="h-8 rounded bg-slate-100" />)}</div>
        </div>
        {ios && <div className="flex h-6 items-center justify-center bg-slate-100"><span className="pph-target relative text-[#0053DA]"><Share className="h-3 w-3" /></span></div>}
      </div>
      {ios ? (
        <div className="pph-sheet absolute inset-x-0 bottom-0 rounded-t-xl border-t border-slate-200 bg-slate-50 p-1.5 text-[7px] text-slate-700 shadow-lg">
          <p className="px-1 py-0.5 text-slate-400">Copy</p>
          <p className="pph-pick flex items-center justify-between rounded px-1 py-0.5">Add to Home Screen <Plus className="h-2.5 w-2.5" /></p>
          <p className="px-1 py-0.5 text-slate-400">Bookmark</p>
        </div>
      ) : (
        <div className="pph-sheet absolute right-1 top-5 w-24 rounded-md border border-slate-200 bg-white py-1 text-[7px] text-slate-700 shadow-lg">
          <p className="px-2 py-0.5 text-slate-400">New tab</p>
          <p className="pph-pick mx-1 rounded px-1 py-0.5">Install app</p>
        </div>
      )}
      <div className="pph-confirm absolute inset-x-2 top-16 rounded-lg border border-slate-200 bg-white p-1.5 shadow-xl">
        <p className="text-[8px] font-bold text-slate-900">{ios ? "Add to Home Screen" : "Install app?"}</p>
        <p className="flex items-center gap-1 py-1 text-[7px] text-slate-600"><span className="flex h-3.5 w-3.5 items-center justify-center rounded bg-[#0053DA] text-[5px] font-bold text-white">SL</span> SnapList</p>
        <div className="flex justify-end"><span className="pci-btn rounded-full bg-[#0053DA] px-1.5 py-0.5 text-[7px] font-semibold text-white">{ios ? "Add" : "Install"}</span></div>
      </div>
      <div className="pph-home absolute inset-0 grid grid-cols-4 content-start gap-2 bg-gradient-to-b from-sky-300 to-indigo-400 p-3 pt-5">
        {Array.from({ length: 7 }, (_, i) => <span key={i} className="h-5 w-5 rounded-md bg-white/40" />)}
        <span className="pci-dock flex h-5 w-5 items-center justify-center rounded-md bg-[#0053DA] text-[6px] font-bold text-white ring-1 ring-white">SL</span>
      </div>
      <span className={`pph-finger ${ios ? "" : "pph-finger-android"} absolute h-4 w-4 rounded-full border-2 border-white bg-slate-900/40`} />
    </div>
  );
}
